module.exports = __webpack_public_path__ + "media/images/rebate-7ae75a4ebe219750a32e7f896ea6ca78.png";